// utils/useSelectRow.js
import { useState } from 'react';

// 行の選択を管理するカスタムフック
export const useSelectRow = (itemIdKey) => {
  const [selectedItems, setSelectedItems] = useState([]);

  // 行の選択状態を変更する関数
  const handleRowSelect = (itemId) => {
    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.includes(itemId)) {
        return prevSelectedItems.filter((id) => id !== itemId); // チェックを外す
      } else {
        return [...prevSelectedItems, itemId]; // チェックを入れる
      }
    });
  };

  // 全選択/全解除の処理
  const handleSelectAll = (e, items) => {
    if (e.target.checked) {
      // すべてのアイテムを選択
      setSelectedItems(items.map((item) => item[itemIdKey]));
    } else {
      // すべてのアイテムを選択解除
      setSelectedItems([]);
    }
  };

  return {
    selectedItems,
    setSelectedItems,
    handleRowSelect,
    handleSelectAll,
  };
};
